import React, { useEffect, useMemo } from "react";
import "../scss/button.scss";
import "../scss/ApplicationUnsuccessful.scss";
import { ReactComponent as ClipboardCross } from "../images/clipboard-cross.svg";
import { ReactComponent as StarfinLogo } from "../images/stashfin-logo.svg";
import PageHeader from "../components/PageHeader";
import { useNavigate } from "react-router-dom";

function ApplicationUnsuccessful() {

  const navigate = useNavigate();
  
    const exitApplication = () => {
      const partnrrdrct = localStorage.getItem('partnerRedirect')
      if (partnrrdrct) {
        window.location.href = partnrrdrct
      } else {
        navigate('/')
      }
    }

  return (

       <div className="application-unsuccessful-page-container">
         <PageHeader />
        <div className="application-unsuccessful">
          <div className="checkmark-container">
            <div className="checkmark-circle">
              <ClipboardCross className="checkmark-icon" />
            </div>
          </div>
          <h1 className="title">Application Unsuccessful</h1>
          <p className="subtitle">
          Please come back after sometime to try again.
          </p>
        </div>
        <div className="bottom-footer">
          <p className="powered-by">
            {" "}
            Powered by <StarfinLogo />{" "}
          </p>
          <button
            type="submit"
            className="btn btn-primary"
            onClick={exitApplication}
          >
            Close
          </button>
        </div>
       </div>
       
      
  );
}

export default ApplicationUnsuccessful;
